<ng-template transloco let-t>
  <e-entity-table class="dock-y" [headers]="headers" [config]="config">
    <ng-container eTableColumn="key">
      <ng-template eTableCell let-item="item">
        {{ item.key }}
        @if (item.key === 'Platform') {
          <e-badge class="ml-2" color="info" small prependIcon="info-circle">
            Bovenaan de applicatie
          </e-badge>
        }
      </ng-template>
    </ng-container>
    <ng-container eTableColumn="level">
      <ng-template eTableCell let-item="item">
        {{ t('enums.notificationLevel.' + item.level) }}
      </ng-template>
    </ng-container>
    <ng-container eTableColumn="show">
      <ng-template eTableCell let-item="item">
        @if (item.show === 1) {
          <i eIcon icon="check-circle"></i>
        }
        @if (item.show === 2) {
          <span style="font-size: 0.8em">
            <i eIcon icon="calendar-alt"></i>
            {{ item.showFrom | dateTimeFormat : 'monthAsWordWithTime' }} -
            {{ item.showTo | dateTimeFormat : 'monthAsWordWithTime' }}
          </span>
        }
      </ng-template>
    </ng-container>
  </e-entity-table>
</ng-template>
